import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=7a874550&scoped=true"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"
import style0 from "./Errors.vue?vue&type=style&index=0&id=7a874550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a874550",
  null
  
)

export default component.exports